import { useRef } from "react";

export default function ResizeHandle({onResize,color="#4a5060"}:{onResize:(delta:number)=>void,color?:string}){
  const sx=useRef<number|null>(null);
  const onMouseDown=(e:React.MouseEvent)=>{
    e.preventDefault();sx.current=e.clientX;
    const move=(ev:MouseEvent)=>onResize(ev.clientX-(sx.current??ev.clientX));
    const up=()=>{document.removeEventListener("mousemove",move);document.removeEventListener("mouseup",up);};
    document.addEventListener("mousemove",move);document.addEventListener("mouseup",up);
  };
  return <span onMouseDown={onMouseDown} style={{position:"absolute",right:0,top:0,bottom:0,width:7,cursor:"col-resize",display:"flex",alignItems:"center",justifyContent:"center",zIndex:2}}>
    <span style={{width:2,height:"55%",background:color,borderRadius:3,opacity:.6}}/>
  </span>;
}
